module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Risch_Rotkreuz-de6ecd95c4fa8f7f5a9c47cf8852eec4.svg";